import { createFileRoute } from "@tanstack/react-router";
import { MerchOutboxView } from "../../components/merch/outbox-view";
import { keysetSearch } from "../../lib/list-page/list-search";

/** Merchandising › Outbox: the simulated emails the store sent, newest first (keyset). */
export const Route = createFileRoute("/_app/merchandising/outbox")({
	validateSearch: keysetSearch({}),
	component: OutboxPage,
});

function OutboxPage() {
	return <MerchOutboxView search={Route.useSearch()} navigate={Route.useNavigate()} />;
}
